import React from 'react'
import Navbar from '../../Navbar'
import AddComprobante from './AddComprobante'
function PantallaGeneral() {
    
  return (
    <div>
        <Navbar/>
        <AddComprobante/>
    </div>
  )
}

export default PantallaGeneral
